module.exports = __webpack_public_path__ + "img/html-evolution-5.e5c67e0f.jpg";